module.exports = __webpack_public_path__ + "8b404322250d2f5050231f2a1b558cb9.jpg";